import React from 'react';
import PropTypes from 'prop-types';

import { MultipleItemsCarousel } from './MultipleItemsCarousel';

import City from './City';

// styles
import './CityCarousel.scss';

const CityCarousel = props => {
  const { cities, page, numberOfItems } = props;

  const renderCarouselItem = city => {
    return (
      <City
        key={`${city.id}`}
        id={city.id}
        numberOfRentableUnits={city.numberOfRentableUnits}
        country={city.country.countryId.toLowerCase()}
      />
    );
  };

  return (
    <div className="city-carousel">
      <MultipleItemsCarousel
        items={cities.map(city => renderCarouselItem(city))}
        itemsPerSwipe={numberOfItems}
        selectedPage={page}
      />
    </div>
  );
};

CityCarousel.propTypes = {
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      country: PropTypes.string
    })
  ).isRequired,
  page: PropTypes.number.isRequired,
  numberOfItems: PropTypes.number.isRequired
};

export default CityCarousel;
